<script lang="ts">
	import type { IEventFaqsItem } from '@api/EventFaqsApi';
	import SectionHeadline from './SectionHeadline.svelte';
	import Accordion from '@components/LpgComponents/Accordion.svelte';
	import StructuredFaqData from './StructuredFaqData.svelte';

	export let headline: string;
	export let items: IEventFaqsItem[];
</script>

<div class="content-module-padding">
	<SectionHeadline {...$$restProps}>{headline}</SectionHeadline>

	<div
		class="grid grid-cols-1 lg:grid-cols-2 lg:gap-x-6 xl:gap-x-15 lg:items-start wysisyg-content lg:pl-9"
	>
		{#each items as item, i}
			<!-- eslint-disable -->
			<Accordion question={item.question} id={i.toString()}>{@html item.answer}</Accordion>
		{/each}
	</div>
</div>
<StructuredFaqData {items} />
